import { router, useForm } from "@inertiajs/react";
import { FormularyTierForm } from "../Components/Forms";
import FormularyTierResults from "../Components/TierSearch/FormularyTierResults";
import { FormularyTierPageProps } from "../types";
import { TierSearchDisclaimer } from "../Components/TierSearch";

const FormularyTierPage = ({
    tierSearchResults,
    drugNames,
    pageState,
}: FormularyTierPageProps) => {
    const form = useForm({
        action: "FORMULARY_TIER",
        card_id: pageState.cardId ?? "",
        group_id: pageState.groupId ?? "",
        drug_name: pageState.drugName ?? "",
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        form.post(route("portals.patient.coverage.search"));
    };

    const handleSelect = (drug: string) => {
        form.setData("drug_name", drug);
        router.post(route("portals.patient.coverage.search"), {
            ...form.data,
            drug_name: drug,
        });
    };

    return (
        <>
            <FormularyTierForm form={form} onSubmit={handleSubmit} />

            {drugNames?.length && (
                <div className="w-full">
                    <FormularyTierResults
                        drugNames={drugNames}
                        onSelect={(option) => handleSelect(option)}
                        tierSearchResults={tierSearchResults ?? null}
                    />
                </div>
            )}

            <TierSearchDisclaimer />
        </>
    );
};

export default FormularyTierPage;
